import React, { Component } from 'react';

class Sidebar extends Component {
    constructor(props) {
        super(props);
    
        this.toggle = this.toggle.bind(this);
        this.state = {
          isOpen: false
        };
    }
    toggle() {
        this.setState({
          isOpen: !this.state.isOpen
        });
    }
    render() {
        return (
            <nav className="col-md-2 d-none d-md-block bg-light sidebar">
                <div className="sidebar-sticky">
                    <ul className="nav flex-column">
                        <li className="nav-item">
                            <a className="nav-link" href="/admin/events">Certificate Events</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="/admin/marketing-events">Marketing Events</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="/admin/registrations">Registrations</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="/admin/password">Change Password</a>
                        </li>
                    </ul>
                </div>
            </nav>
        );
    }
}
export default Sidebar;
